/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LanguageEntryValue } from '../models/language-entry-value';
import { ThemeEntryDto } from '../models/theme-entry-dto';
import { TimeZoneEntryDto } from '../models/time-zone-entry-dto';
import { UiSettingsEntryDto } from '../models/ui-settings-entry-dto';

@Injectable({ providedIn: 'root' })
export class UiSettingsControllerService extends DataBaseService {

  /**
   * Path part for operation uiSettingsControllerGetFontFile
   */
  static readonly UiSettingsControllerGetFontFilePath = '/v1/fonts/files/{fontId}/{format}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFontFile$FontWoff()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFontFile$FontWoff$Response(params: {
    fontId: string;
    format: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetFontFilePath, 'get');
    if (params) {
      rb.path('fontId', params.fontId, {});
      rb.path('format', params.format, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/font-woff',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFontFile$FontWoff$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFontFile$FontWoff(params: {
    fontId: string;
    format: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.getFontFile$FontWoff$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFontFile$FontWoff2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFontFile$FontWoff2$Response(params: {
    fontId: string;
    format: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetFontFilePath, 'get');
    if (params) {
      rb.path('fontId', params.fontId, {});
      rb.path('format', params.format, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/font-woff2',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFontFile$FontWoff2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFontFile$FontWoff2(params: {
    fontId: string;
    format: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.getFontFile$FontWoff2$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFontFile$Ttf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFontFile$Ttf$Response(params: {
    fontId: string;
    format: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetFontFilePath, 'get');
    if (params) {
      rb.path('fontId', params.fontId, {});
      rb.path('format', params.format, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'font/ttf',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFontFile$Ttf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFontFile$Ttf(params: {
    fontId: string;
    format: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.getFontFile$Ttf$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFontFile$Otf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFontFile$Otf$Response(params: {
    fontId: string;
    format: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetFontFilePath, 'get');
    if (params) {
      rb.path('fontId', params.fontId, {});
      rb.path('format', params.format, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'font/otf',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFontFile$Otf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFontFile$Otf(params: {
    fontId: string;
    format: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.getFontFile$Otf$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetAvailableDateFormats
   */
  static readonly UiSettingsControllerGetAvailableDateFormatsPath = '/v1/formats/date';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableDateFormats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableDateFormats$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<any>>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetAvailableDateFormatsPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<any>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableDateFormats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableDateFormats(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<any>> {

    return this.getAvailableDateFormats$Response(params).pipe(
      map((r: StrictHttpResponse<Array<any>>) => r.body as Array<any>)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetAvailableDateTimeFormats
   */
  static readonly UiSettingsControllerGetAvailableDateTimeFormatsPath = '/v1/formats/date-time';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableDateTimeFormats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableDateTimeFormats$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<any>>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetAvailableDateTimeFormatsPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<any>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableDateTimeFormats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableDateTimeFormats(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<any>> {

    return this.getAvailableDateTimeFormats$Response(params).pipe(
      map((r: StrictHttpResponse<Array<any>>) => r.body as Array<any>)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetAvailableTimeFormats
   */
  static readonly UiSettingsControllerGetAvailableTimeFormatsPath = '/v1/formats/time';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableTimeFormats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableTimeFormats$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<any>>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetAvailableTimeFormatsPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<any>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableTimeFormats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableTimeFormats(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<any>> {

    return this.getAvailableTimeFormats$Response(params).pipe(
      map((r: StrictHttpResponse<Array<any>>) => r.body as Array<any>)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetLanguageTranslationFile
   */
  static readonly UiSettingsControllerGetLanguageTranslationFilePath = '/v1/language/files/{langCode}/{platform}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLanguageTranslationFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguageTranslationFile$Response(params: {
    langCode: string;
    platform: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetLanguageTranslationFilePath, 'get');
    if (params) {
      rb.path('langCode', params.langCode, {});
      rb.path('platform', params.platform, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getLanguageTranslationFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLanguageTranslationFile(params: {
    langCode: string;
    platform: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.getLanguageTranslationFile$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetAvailableLanguages
   */
  static readonly UiSettingsControllerGetAvailableLanguagesPath = '/v1/language';

  /**
   * return all available languages
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableLanguages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableLanguages$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<LanguageEntryValue>>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetAvailableLanguagesPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LanguageEntryValue>>;
      })
    );
  }
  /**
   * return all available languages
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableLanguages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableLanguages(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<LanguageEntryValue>> {

    return this.getAvailableLanguages$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LanguageEntryValue>>) => r.body as Array<LanguageEntryValue>)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetAnonymousUserUiSettings
   */
  static readonly UiSettingsControllerGetAnonymousUserUiSettingsPath = '/v1/settings/user/anonymous';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAnonymousUserUiSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnonymousUserUiSettings$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<UiSettingsEntryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetAnonymousUserUiSettingsPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UiSettingsEntryDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAnonymousUserUiSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnonymousUserUiSettings(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<UiSettingsEntryDto> {

    return this.getAnonymousUserUiSettings$Response(params).pipe(
      map((r: StrictHttpResponse<UiSettingsEntryDto>) => r.body as UiSettingsEntryDto)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetUserUiSettings
   */
  static readonly UiSettingsControllerGetUserUiSettingsPath = '/v1/settings/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserUiSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserUiSettings$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<UiSettingsEntryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetUserUiSettingsPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UiSettingsEntryDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserUiSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserUiSettings(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<UiSettingsEntryDto> {

    return this.getUserUiSettings$Response(params).pipe(
      map((r: StrictHttpResponse<UiSettingsEntryDto>) => r.body as UiSettingsEntryDto)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetAnonymousAvailableThemes
   */
  static readonly UiSettingsControllerGetAnonymousAvailableThemesPath = '/v1/themes/anonymous';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAnonymousAvailableThemes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnonymousAvailableThemes$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<ThemeEntryDto>>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetAnonymousAvailableThemesPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ThemeEntryDto>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAnonymousAvailableThemes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnonymousAvailableThemes(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<ThemeEntryDto>> {

    return this.getAnonymousAvailableThemes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ThemeEntryDto>>) => r.body as Array<ThemeEntryDto>)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetThemeCssFile
   */
  static readonly UiSettingsControllerGetThemeCssFilePath = '/v1/themes/files/{themeId}/css';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getThemeCssFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getThemeCssFile$Response(params: {
    themeId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetThemeCssFilePath, 'get');
    if (params) {
      rb.path('themeId', params.themeId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/css',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getThemeCssFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getThemeCssFile(params: {
    themeId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.getThemeCssFile$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetThemeDetails
   */
  static readonly UiSettingsControllerGetThemeDetailsPath = '/v1/themes/{themeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getThemeDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getThemeDetails$Response(params: {
    themeId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<ThemeEntryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetThemeDetailsPath, 'get');
    if (params) {
      rb.path('themeId', params.themeId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ThemeEntryDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getThemeDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getThemeDetails(params: {
    themeId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<ThemeEntryDto> {

    return this.getThemeDetails$Response(params).pipe(
      map((r: StrictHttpResponse<ThemeEntryDto>) => r.body as ThemeEntryDto)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetAvailableThemes
   */
  static readonly UiSettingsControllerGetAvailableThemesPath = '/v1/themes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableThemes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableThemes$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<ThemeEntryDto>>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetAvailableThemesPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ThemeEntryDto>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableThemes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableThemes(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<ThemeEntryDto>> {

    return this.getAvailableThemes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ThemeEntryDto>>) => r.body as Array<ThemeEntryDto>)
    );
  }

  /**
   * Path part for operation uiSettingsControllerGetAvailableTimeZones
   */
  static readonly UiSettingsControllerGetAvailableTimeZonesPath = '/v1/time-zone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableTimeZones()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableTimeZones$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<TimeZoneEntryDto>>> {

    const rb = new RequestBuilder(this.rootUrl, UiSettingsControllerService.UiSettingsControllerGetAvailableTimeZonesPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TimeZoneEntryDto>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableTimeZones$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableTimeZones(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<TimeZoneEntryDto>> {

    return this.getAvailableTimeZones$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TimeZoneEntryDto>>) => r.body as Array<TimeZoneEntryDto>)
    );
  }

}
